"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _principles = require("@kbbcomponentlibrary/principles");

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var StyledIcon = (
/*#__PURE__*/
0, _styledBase["default"])('svg', {
  target: "e1cy9q2n0",
  label: "StyledIcon"
})("color:", _principles.colors.common.black, ";height:", function (props) {
  return props.size;
}, "px;width:", function (props) {
  return props.size;
}, "px;fill:", function (props) {
  return props.colorFill;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9JY29uQmFzZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjZ0MiLCJmaWxlIjoiLi4vc3JjL0ljb25CYXNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyplc2xpbnQgaW1wb3J0L25hbWVzcGFjZTogWydlcnJvcicsIHsgYWxsb3dDb21wdXRlZDogdHJ1ZSB9XSovXG4vLyBAZmxvd1xuXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnQGtiYmNvbXBvbmVudGxpYnJhcnkvcHJpbmNpcGxlcyc7XG5cbnR5cGUgaWNvblByb3BzID0ge1xuICBzaXplOiBudW1iZXIsXG4gIHZpZXdCb3g6IHN0cmluZyxcbiAgY29sb3JGaWxsOiBzdHJpbmcsXG4gIGNoaWxkcmVuPzogUmVhY3QuRWxlbWVudDwqPixcbn07XG5cbmNvbnN0IFN0eWxlZEljb24gPSBzdHlsZWQoJ3N2ZycpYFxuICBjb2xvcjogJHtjb2xvcnMuY29tbW9uLmJsYWNrfTtcbiAgaGVpZ2h0OiAkeyhwcm9wczogaWNvblByb3BzKSA9PiBwcm9wcy5zaXplfXB4O1xuICB3aWR0aDogJHsocHJvcHM6IGljb25Qcm9wcykgPT4gcHJvcHMuc2l6ZX1weDtcbiAgZmlsbDogJHsocHJvcHM6IGljb25Qcm9wcykgPT4gcHJvcHMuY29sb3JGaWxsfTtcbmA7XG5cbmNvbnN0IEljb25CYXNlID0gKHByb3BzOiBpY29uUHJvcHMpID0+IChcbiAgPFN0eWxlZEljb24gey4uLnByb3BzfT5cbiAgICB7cHJvcHMuY2hpbGRyZW59XG4gIDwvU3R5bGVkSWNvbj5cbik7XG5cbkljb25CYXNlLmRpc3BsYXlOYW1lID0gJ0ljb25CYXNlJztcblxuSWNvbkJhc2UuZGVmYXVsdFByb3BzID0ge1xuICBzaXplOiAyNCxcbiAgY29sb3JGaWxsOiBjb2xvcnMuY29tbW9uLmJsYWNrLFxuICB2aWV3Qm94OiAnMCAwIDUxMiA1MTInLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSWNvbkJhc2U7XG4iXX0= */"));

var IconBase = function IconBase(props) {
  return _react["default"].createElement(StyledIcon, props, props.children);
};

IconBase.displayName = 'IconBase';
IconBase.defaultProps = {
  size: 24,
  colorFill: _principles.colors.common.black,
  viewBox: '0 0 512 512'
};
var _default = IconBase;
exports["default"] = _default;
IconBase.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconBase",
  "props": {
    "size": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "colorFill": {
      "defaultValue": {
        "value": "colors.common.black",
        "computed": true
      },
      "required": false,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "viewBox": {
      "defaultValue": {
        "value": "'0 0 512 512'",
        "computed": false
      },
      "required": false,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element<*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/IconBase.js"] = {
    name: "IconBase",
    docgenInfo: IconBase.__docgenInfo,
    path: "src/IconBase.js"
  };
}